export const mockCarePlanData = {
  data: {
    fluidTracking: {
      enabled: true,
      intakeTarget: 3200,
    },
  },
}
